import { Box } from '@mui/material';
import React from 'react';
import CAppFilterSelect from '../../../../../../../app/components/CAppFilterSelect';
import IFund from '../../../../../interfaces/fund/IFund';
import IInvestExpertiseFilters from '../../../../../interfaces/expertise/IInvestExpertiseFilters';
import { useTranslation } from 'react-i18next';
import { TInvestFundRiskLevelTag } from '../../../../../types/fund/TInvestFundRiskLevelTag';

type CFiltersRiskLevelSelectProps = {
	optionsRiskLevels: { id: TInvestFundRiskLevelTag; name: string }[];
	filters: IInvestExpertiseFilters;
	onChange: (filters: IInvestExpertiseFilters) => void;
	label: string;
	multipleRenderLabelLangTag: string;
};

const CFiltersRiskLevelSelect = (props: CFiltersRiskLevelSelectProps) => {
	const { optionsRiskLevels, filters, onChange, label, multipleRenderLabelLangTag } = props;

	const { t } = useTranslation();

	return (
		<>
			{optionsRiskLevels ? (
				<CAppFilterSelect
					className="filter-risk-level"
					multiple
					multipleRenderTags={(val: IFund[]) => (
						<Box style={{ paddingLeft: '5px', fontSize: '0.85rem' }}>
							{t(multipleRenderLabelLangTag, { count: val ? val.length : 0 })}
						</Box>
					)}
					value={
						filters?.riskLevels ? optionsRiskLevels.filter((x) => filters.riskLevels?.includes(x.id)) : null
					}
					onChange={(val: { id: TInvestFundRiskLevelTag; name: string }[]) =>
						onChange({
							...filters,
							riskLevels: val ? val.map((x) => x.id) : null,
						})
					}
					label={label}
					size="small"
					options={optionsRiskLevels}
				/>
			) : (
				<></>
			)}
		</>
	);
};

export default CFiltersRiskLevelSelect;
